'use client';

import Link from 'next/link';
import { IconSearch } from '@picsart/design-system/foundation/icons/IconSearch';

import { SEARCH_PATH } from '@/constants/search';
import useStyles from './styles';

/**
 * Search, on a screen too narrow for a field.
 *
 * A link rather than an in-header expansion: `/search` already exists, so this
 * needs no state, no overlay and no second search surface to keep in step with
 * the header's.
 */
const HeaderSearchLink = () => {
  const classes = useStyles();

  return (
    <Link href={SEARCH_PATH} className={classes.link} aria-label="Search">
      <IconSearch className={classes.icon} aria-hidden="true" />
    </Link>
  );
};

export default HeaderSearchLink;
